module.exports = __webpack_public_path__ + "static/media/circleArrowSideClose.98d6013e.svg";